export default __webpack_public_path__ + "media/images/rabbit_ui_announce-4eecf68de18e4d354fe5b16beb8117e2.png";